import { render, staticRenderFns } from "./DocumentsModal.vue?vue&type=template&id=82be7322&scoped=true&"
import script from "./DocumentsModal.vue?vue&type=script&lang=js&"
export * from "./DocumentsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82be7322",
  null
  
)

export default component.exports